import { Box, Flex, IconButton, Table } from "@radix-ui/themes";
import { ArrowDownAZ, ArrowUpZA, ArrowDownUp } from "lucide-react";
import ColumnFilter from "./ColumnFilter";
import {
  AccessorFnColumnDef,
  ColumnDef,
  ColumnFiltersState,
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  getFilteredRowModel,
  getSortedRowModel,
  useReactTable,
  Table as ReactTable,
  Row
} from "@tanstack/react-table";
import React from "react";

interface Props<T> {
  table: ReactTable<T>
  handleRowOnClick?: ((row: Row<T>, idx?: number) => void)
}

export default function BasicTable<T>({table, handleRowOnClick}: Props<T>) {
  return (
    
    <Box>
      <Table.Root>
        <Table.Header>
          {table.getHeaderGroups().map((headerGroup) => (
            <Table.Row key={headerGroup.id}>
              {headerGroup.headers.map((header) => (
                <Table.ColumnHeaderCell key={header.id}>
                  <Flex justify="between" gap="4">
                    {flexRender(
                      header.column.columnDef.header,
                      header.getContext(),
                    )}
                    <Flex gap="2">
                      {header.column.getCanSort() ? (
                        <IconButton
                          size="1"
                          variant="soft"
                          onClick={header.column.getToggleSortingHandler()}
                        >
                          {{
                            asc: <ArrowDownAZ size="16px" />,
                            desc: <ArrowUpZA size="16px" />,
                          }[header.column.getIsSorted() as string] ?? (
                            <ArrowDownUp size="16px" />
                          )}
                        </IconButton>
                      ) : null}
                      {header.column.getCanFilter() ? (
                        <ColumnFilter column={header.column} />
                      ) : null}
                    </Flex>
                  </Flex>
                </Table.ColumnHeaderCell>
              ))}
            </Table.Row>
          ))}
        </Table.Header>
        <Table.Body>
          {table.getRowModel().rows.map((row, idx) => (
            <Table.Row
              key={row.id}
              style={{ cursor: "pointer" }}
              onClick={() => handleRowOnClick && handleRowOnClick(row, idx)}
            >
              {row.getVisibleCells().map((cell) => (
                <Table.Cell key={cell.id}>
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </Table.Cell>
              ))}
            </Table.Row>
          ))}
        </Table.Body>
      </Table.Root>
    </Box>
  );
}
